/** A note: a collaborative rich-text document of a workspace (API.md "Documents"). */
export interface WorkspaceDocument {
  id: string;
  workspace_id: string;
  section_id: string | null;
  group_id: string | null;
  name: string;
  owner_user_id: string;
  owner_name: string;
  version: number;
  created_at: string;
  updated_at: string;
  content_updated_at: string | null;
  my_role: string | null;
  my_permissions: string[];
  is_favorite: boolean;
  /** Workspace labels on the note (a team workspace only). */
  labels?: { id: string; name: string; color: string }[];
}

export interface DeletedDocument {
  id: string;
  name: string;
  trashed_at: string;
  purge_after: string;
}

export interface DocumentMedia {
  media_id: string;
  filename: string;
  mime_type: string;
  size_bytes: number;
  is_image: boolean;
  width: number | null;
  height: number | null;
}

export interface DocumentVersion {
  id: string;
  kind: 'auto' | 'manual' | 'before_restore';
  created_at: string;
  created_by_user_id: string | null;
  size_bytes: number;
}

export interface DocumentRule {
  id: string;
  subject_kind: 'role' | 'team' | 'custom_role';
  subject_role: string | null;
  team_id: string | null;
  custom_role_id: string | null;
  subject_name: string;
  role: string;
}

export interface DocumentAccessInfo {
  owner_user_id: string;
  owner_name: string;
  members: { user_id: string; display_name: string; role: string }[];
  rules: DocumentRule[];
  denials: { user_id: string; display_name: string }[];
  assignable_roles: string[];
}

export const DOCUMENT_PERMISSIONS = {
  view: 'document.view',
  comment: 'document.comment',
  editContent: 'document.edit_content',
  editDetails: 'document.edit_details',
  delete: 'document.delete',
  manageAccess: 'document.manage_access',
} as const;

export const CREATE_DOCUMENT = 'workspace.create_document';
export const DOCUMENT_NAME_MAX = 200;
